<template>
  <v-container fluid>

    <v-row dense align="center" justify="space-between" no-gutters>
      <v-col cols="12" md="2" >
        <label class="menunamestyle ml-10">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
      <v-col  cols="12" md="3" >
        <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      </template>
    </v-row>

    <v-row align="center" dense>
      <v-spacer/>
      <v-col cols="12" md="2" sm="12" xs="12">
        <v-menu
          v-model="date1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          :disabled="!checkdate"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_start_date"
              :label="$t('common_search_start')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_start_date" @input="date1 = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>      
      </v-col>
      <v-col cols="12" md="2" sm="12" xs="12">
        <v-menu
          v-model="date2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          :disabled="!checkdate"
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="search_end_date"
              :label="$t('common_search_end')"
              prepend-icon="event"
              readonly outlined dense hide-details
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search_end_date" @input="date2=false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
        </v-menu>                    
      </v-col>
      <v-col cols="12" md="1" sm="6" xs="6" class="d-flex justify-center">
        <v-checkbox v-model="checkdate" dense :label="$t('chartep_label1')"/>
      </v-col>
      <v-col cols="12" md="2" sm="6" xs="6" class="d-flex justify-center">
        <v-btn class="search_btn" elevation="0" outlined large @click="search_run">{{$t("common_ok")}}</v-btn>
        <v-btn class="ml-2" color="#4e6ef7" large rounded @click="startDownload()"><v-icon color="white">cloud_download</v-icon></v-btn>
      </v-col>
    </v-row>
    
    <v-row dense>
      <v-col cols="6" md="3" style="padding:2px"> 
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('chartep_col1')+"(KRW)"}}</label>
          <label class="chartsum_value">{{priceToString(sum1)}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="3" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('chartep_col2')+"(KRW)"}}</label>
        <label class="chartsum_value">{{priceToString(sum2)}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="3" style="padding:2px"> 
        <div class="chartsum_round">
          <label class="chartsum_title">{{$t('chartep_col1')+"(USD)"}}</label>
          <label class="chartsum_value">{{priceToString(sum3)}}</label>
        </div>
      </v-col>
      <v-col cols="6" md="3" style="padding:2px">
        <div class="chartsum_round">
        <label class="chartsum_title">{{$t('chartep_col2')+"(USD)"}}</label>
        <label class="chartsum_value">{{priceToString(sum4)}}</label>
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-5">
      <v-col>
        <v-simple-table 
          height="70vh"
          dense fixed-header
          class="datatablestyle"
          >
          <template v-slot:default>
            <thead style="height:48px">
              <tr>
                <th class="text-left header_text_style">{{$t('chartep_col3')}}</th>
                <th class="text-left header_text_style">{{$t('chartep_col4')}}</th>
                <th class="text-right header_text_style">{{$t('chartep_col5')+"(KRW)"}}</th>
                <th class="text-right header_text_style">{{$t('chartep_col6')+"(KRW)"}}</th>
                <th class="text-right header_text_style">{{$t('chartep_col5')+"(USD)"}}</th>
                <th class="text-right header_text_style">{{$t('chartep_col6')+"(USD)"}}</th>
              </tr>
            </thead>
            <tbody>
              <tr style="background-color:#f0f0f0">
                <td class="text-center"></td>
                <td class="text-right">{{$t('chartep_col7')}}</td>
                <td class="text-right">{{ priceToString(sum1) }}</td>
                <td class="text-right">{{ priceToString(sum2) }}</td>
                <td class="text-right">{{ priceToString(sum3) }}</td>
                <td class="text-right">{{ priceToString(sum4) }}</td>
              </tr>
              <tr v-for="item in list" :key="item.ROWNUM">
                <td class="text-left">{{ item.COMNAME }}</td>
                <td class="text-left">{{ item.EVENT_NAME }}</td>
                <td class="text-right">{{ priceToString(item.COST1) }}</td>
                <td class="text-right">{{ priceToString(item.COST2) }}</td>
                <td class="text-right">{{ priceToString(item.COST_USD1) }}</td>
                <td class="text-right">{{ priceToString(item.COST_USD2) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>

import moment from 'moment'
import XLSX from 'xlsx'
export default {

  beforeDestroy(){
  },

  mounted(){

    if(this.$session.get("GRADE") < 10){
      this.$alert(this.$t("common_nograde"));
      this.$router.push("Login");
      return;
    }

    this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
    this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
    this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
    this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
    this.grade = this.$session.get("GRADE");
    
    this.search_start_date  = this.$session.get("EVENT_START");
    if(this.search_start_date == null || this.search_start_date == undefined){
      this.search_start_date = moment().subtract(1, 'YEARS').format("YYYY-MM-DD");
    }
    this.search_end_date    = this.$session.get("EVENT_END");
    if(this.search_end_date == null || this.search_end_date == undefined){
      this.search_end_date   = moment().format("YYYY-MM-DD");
    }

    if(this.$session.exists("ADMIN_IDX")){
      this.initpage();
    }else{
      //키값 없으면 로그인으로
      this.$router.push("Login");
    }
  },

  data: () => ({

      date1:false,
      date2:false,
      search_start_date : '',
      search_end_date : '',
      checkdate : true,
      list:[],
      sum1:0,
      sum2:0,
      sum3:0,
      sum4:0,

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

  }),

  methods: {
    
    startDownload(){

      this.$confirm(this.$t('common_downexcel2')).then(() => {

        var templist = [];
        this.list.forEach(item=>{
          templist.push({
            "COMNAME":item.COMNAME
          , "EVENT_NAME":item.EVENT_NAME
          , "COST1":parseInt(item.COST1)
          , "COST2":parseInt(item.COST2)
          , "COST3":parseInt(item.COST_USD1)
          , "COST4":parseInt(item.COST_USD2)
          });
        });

        //하단 합계 넣기
        templist.push({
            "COMNAME":""
          , "EVENT_NAME":""
          , "COST1":this.sum1
          , "COST2":this.sum2
          , "COST3":this.sum3
          , "COST4":this.sum4
        });
        
        var item_sheet = XLSX.utils.json_to_sheet(templist);

        //상단 컬럼명 수정
        item_sheet.A1 = {v:this.$t('chartep_col3')};
        item_sheet.B1 = {v:this.$t('chartep_col4')};
        item_sheet.C1 = {v:this.$t('chartep_col5')+"(KRW)"};
        item_sheet.D1 = {v:this.$t('chartep_col6')+"(KRW)"};
        item_sheet.E1 = {v:this.$t('chartep_col5')+"(USD)"};
        item_sheet.F1 = {v:this.$t('chartep_col6')+"(USD)"};

        //컬럼별 너비
        var wscols = [{wch:20},{wch:30},{wch:10},{wch:10}];
        item_sheet['!cols'] = wscols;

        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('chartep_label2'));
        XLSX.writeFile(wb, this.$t('chartep_label2')+'_'+moment().format('YYYYMMDDHHmmss')+'.xlsx');

      });    
      
    },

    initpage(){
      this.search_run();
    },

    search_run(){

      if(this.grade < 99){
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('chartep_label3'));
          return;
        }
      }

      if(this.checkdate){
        if(this.search_start_date.length < 4){
          this.$alert(this.$t('common_search_start_info1'));
          return;
        }
        if(this.search_end_date.length < 4){
          this.$alert(this.$t('common_search_end_info1'));
          return;
        }
        if(this.search_start_date > this.search_end_date){
          this.$alert(this.$t('common_search_date_error1'));
          return;
        }
      }

      this.$http.post(this.$host+'/api/ChartEventPayment',{
            ADMIN_IDX: this.$session.get("ADMIN_IDX")
          , COM_IDX:   this.SEARCH_COM_IDX == undefined ? '' : this.SEARCH_COM_IDX
          , CHECKDATE: this.checkdate
          , search_start_date:this.search_start_date == undefined ? '' : this.search_start_date
          , search_end_date:this.search_end_date == undefined ? '' : this.search_end_date
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{

        
        this.loading = false;
        
        if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            this.sum1 = 0;
            this.sum2 = 0;
            this.sum3 = 0;
            this.sum4 = 0;
            this.list.splice(0, this.list.length);   //데이터 초기화
            this.list = result.data.resultData;
            this.list.forEach(item =>{
              this.sum1 += parseInt(item.COST1);
              this.sum2 += parseInt(item.COST2);
              this.sum3 += parseInt(item.COST_USD1);
              this.sum4 += parseInt(item.COST_USD2);
            })


        }else if(result.data.resultCode == 2){
          //로그인 필요
          this.$alert(this.$t("common_tokener"));
          this.$session.clear("ADMIN_IDX");
          this.$session.clear("COM_IDX");
          this.$session.clear("ACNT_IDX");
          this.$session.clear("GRADE");
          this.$session.clear("COM_NAME");
          this.$session.clear("ACCESSTOKEN");
          this.$session.clear("REFLASHTOKEN");
          this.$router.push('Login');   //로그인 페이지로 이동

        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
        
        this.loading = false;
        if(error.message == 'Request failed with status code 429')
        {
          this.$alert(this.$t("common_reqer"));
        }else{
          this.$alert(error.message);
        }
      });

    },

    priceToString(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },


    // eslint-disable-next-line no-unused-vars
    comsearchclear(var2){
        this.SEARCH_COM_IDX    = null;
        this.SEARCH_COM_NAME   = '';
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.search_run();
    },

    //검색조건 업체 설정
    comsearchcb(val1){
      if(val1.NAME.length > 0){
        this.SEARCH_COM_NAME = val1.NAME;
        this.SEARCH_COM_IDX  = val1.IDX;
        this.$session.set("COM_IDX", val1.IDX);
        this.$session.set("COM_NAME", val1.NAME);
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");

      }else{
        this.SEARCH_COM_NAME = '';
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_EVENT_IDX = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");

      }
      this.search_run();
    },



  }
    
}

</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>



</style>